import { useState } from "react";

import styles from "@styles/forms-flow/creative.module.scss";

import {
  Button,
  Drawer,
  Hairline,
  Label,
  Select,
  Steps as StepsComponent,
} from "@components";

import { CreativeName } from "./components/CreativeName";

import { useEffect } from "react";
import { ContemplationInterval } from "./components/ContemplationInterval";
import { WhatsAppMessage } from "./components/WhatsAppMessage";
import { FlowAPI } from "providers/FlowAPI";
import { WhatsAppPreview } from "./components/WhatsAppPreview";
import Coupons from "./components/Coupons";

const Steps = {
  NAME: 1,
  CONTEMPLATION: 2,
  CHOOSE_BENEFIT: 3,
  MESSAGE_WHATSAPP: 4,
  FINISHED: 5,
};

export const WhatsAppCreativeActionForm = ({
  visible,
  onClose,
  flowType,
  node,
  restrictions,
  onChange,
  onSave,
}) => {
  const [steps, setSteps] = useState(Object.keys(Steps).length);
  const [currentStep, setCurrentStep] = useState(Steps.NAME);
  const [creative, setCreative] = useState({
    creative: node?.data?.creative || {},
    coupon: node?.data?.coupon || {},
  });
  const [isValid, setIsValid] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [brandsList, setBrands] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const getFreshNode = (data) => {
    return {
      ...node,
      data: {
        ...node.data,
        ...data,
      },
    };
  };

  const getTemplates = async () => {
    // InfoBip
    // const response = await OlgaEnvironmentsAPI.getWhatsappTemplates();
    // const data = response.getData([]);
    // const templatesApproved = (data || []).filter(
    //   (template) => template.status == "APPROVED"
    // );

    const response = await FlowAPI.getWhatsAppResourceTemplates({
      environmentId: node?.environmentId,
    });

    const data = response.getData([]);
    const templatesApproved = data || [];

    if (templatesApproved.length == 0) {
      return setTemplates([
        {
          label: "Não há templates aprovados",
          value: null,
        },
      ]);
    }

    setTemplates(templatesApproved);
    setSelectedTemplate(
      templatesApproved.find((t) => t.id === creative?.template_id)
    );
  };

  useEffect(() => {
    if (restrictions?.lockCreativeBenefit) {
      setSteps(
        Object.values(Steps).filter((stepIndex) =>
          [Steps.NAME, Steps.MESSAGE_WHATSAPP].includes(stepIndex)
        )
      );
    }
  }, []);

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    const c = {
      creative: node?.data?.creative || {},
      coupon: node?.data?.coupon || {},
    };
    setCreative(c);
    setIsValid(isValidStep(currentStep, c, flowType));
  }, [node]);

  useEffect(() => {
    setIsValid(isValidStep(currentStep, creative, flowType));
  }, [currentStep]);

  const onChangeCreative = (branch, value) => {
    let newCreative = {
      ...creative,
      [branch]: {
        ...(creative[branch] || {}),
        ...value,
      },
    };

    if (branch === "creative" && value.templateId) {
      newCreative = {
        ...newCreative,
        message: {
          ...(newCreative.message || {}),
          templateId: value.templateId,
        },
      };
    }

    setCreative(newCreative);
    setIsValid(isValidStep(currentStep, newCreative, flowType));
    onChange && onChange(getFreshNode(newCreative));
    return getFreshNode(newCreative);
  };

  const nextStep = (futureCreative) => {
    const nextStep = getNextStep(
      currentStep,
      futureCreative || creative,
      restrictions,
      brandsList || []
    );
    onSave && onSave(getFreshNode(futureCreative || creative), false);

    return nextStep;
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => {
        setCurrentStep(Steps.NAME);
        onClose();
      }}
      showBackButton={currentStep > Steps.NAME && currentStep != Steps.FINISHED}
      backButton={() =>
        setCurrentStep((prevState) =>
          getPrevStep(prevState, creative, restrictions, brandsList || [])
        )
      }
      title={"Adicionar um criativo - WhatsApp"}
    >
      <StepsComponent steps={steps} stepsIsArray currentStep={currentStep} />

      <div className={styles.scrollContainer}>
        {currentStep === Steps.NAME && (
          <CreativeName
            node={node}
            flowType={flowType}
            restrictions={restrictions}
            creative={creative?.creative}
            onChangeCreative={(data) => onChangeCreative("creative", data)}
          />
        )}

        {currentStep === Steps.CONTEMPLATION && (
          <ContemplationInterval
            creative={creative?.creative}
            onChangeCreative={(data) => {
              onChangeCreative("creative", data);
            }}
          />
        )}

        {currentStep === Steps.CHOOSE_BENEFIT && (
          <Coupons
            creative={creative?.creative}
            onChangeCreative={(data) => {
              onChangeCreative("creative", data);
            }}
          />
        )}

        {currentStep === Steps.MESSAGE_WHATSAPP && (
          <>
            <Label>Selecione o template aprovado</Label>
            {/* <Select
              value={creative.creative?.message?.templateId}
              onChange={(e) => {
                onChangeCreative("creative", {
                  message: {
                    templateId: e.target.value,
                    type: "WHATSAPP",
                  },
                });
              }}
              options={templates}
            /> */}
            <Select
              value={creative.creative?.template_id}
              onChange={(e) => {
                const new_template = templates.find(
                  (t) => t.id === e.target.value
                );
                setSelectedTemplate(new_template);
                onChangeCreative("creative", {
                  template_id: new_template.id,
                  message: {
                    type: "WHATSAPP",
                    template: new_template,
                  },
                });
              }}
              options={templates.map((item) => ({
                label: item.name,
                value: item.id,
                content: item.content,
              }))}
            />

            {creative.creative?.message?.template && (
              <>
                <Hairline className="mt-30 mb-30" />
                <WhatsAppPreview
                  components={
                    creative.creative?.message?.template?.components || []
                  }
                  coupon={creative?.coupon}
                />
                <Hairline className="mt-30 mb-30" />
                <WhatsAppMessage
                  template_id={creative.creative?.template_id}
                  coupon={creative?.coupon}
                />
              </>
            )}
          </>
        )}

        {currentStep === Steps.FINISHED && (
          <div className={styles.finished}>
            <i className="far fa-check" />
            <p>Seu disparo foi configurado com sucesso!</p>
          </div>
        )}
      </div>

      <div className={styles.footer}>
        <div className="d-flex flex-column w-100">
          {currentStep !== Steps.FINISHED && (
            <>
              <Button
                className="w-100"
                disabled={!isValid}
                onClick={() => setCurrentStep(nextStep())}
                design="primary"
              >
                {Steps.GAIN_REMINDER !== currentStep ? "Próximo" : "Finalizar"}
              </Button>
            </>
          )}

          {currentStep === Steps.FINISHED && (
            <Button
              className="w-100"
              onClick={() => {
                setCurrentStep(Steps.NAME);
                setCreative({});
                onClose();
              }}
            >
              Voltar para fluxos
            </Button>
          )}
        </div>
      </div>
    </Drawer>
  );
};

const getNextStep = (
  currentStep,
  { creative, coupon },
  restrictions = {},
  brandsList = []
) => {
  if (restrictions?.lockCreativeBenefit == true) {
    switch (currentStep) {
      case Steps.NAME:
        return Steps.MESSAGE_WHATSAPP;
      case Steps.MESSAGE_WHATSAPP:
        return Steps.FINISHED;
      default:
        return currentStep;
    }
  }

  switch (currentStep) {
    case Steps.NAME:
      return Steps.CONTEMPLATION;
    case Steps.CONTEMPLATION:
      return Steps.CHOOSE_BENEFIT;
    case Steps.CHOOSE_BENEFIT:
      return Steps.MESSAGE_WHATSAPP;
    case Steps.MESSAGE_WHATSAPP:
      return Steps.FINISHED;
    default:
      return currentStep;
  }
};

const getPrevStep = (
  currentStep,
  { creative, coupon },
  restrictions = {},
  brandsList = []
) => {
  if (restrictions?.lockCreativeBenefit) {
    switch (currentStep) {
      case Steps.NAME:
        return null;
      case Steps.MESSAGE_WHATSAPP:
        return Steps.NAME;
      default:
        return currentStep;
    }
  }

  switch (currentStep) {
    case Steps.NAME:
      return null;
    case Steps.CONTEMPLATION:
      return Steps.NAME;
    case Steps.CHOOSE_BENEFIT:
      return Steps.CONTEMPLATION;
    case Steps.MESSAGE_WHATSAPP:
      return Steps.CHOOSE_BENEFIT;
    default:
      return currentStep;
  }
};

const isValidStep = (currentStep, data, flowType) => {
  const { creative, coupon } = data;

  switch (currentStep) {
    case Steps.NAME:
      return !!creative?.name && !!(flowType == "EVENT" || creative?.sendTime);
    case Steps.CONTEMPLATION:
      return !!creative?.contemplation && !!creative?.contemplation?.type;
    case Steps.MESSAGE_WHATSAPP:
      return !!creative?.template_id;
  }

  return true;
};
